/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Draft_Exercises_CountInputs */

const en_us2_draft_exercises_count = /** @type {(inputs: Draft_Exercises_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercise`);
	return /** @type {LocalizedString} */ (`${i?.count} exercises`)
	
};

const pt_br2_draft_exercises_count = /** @type {(inputs: Draft_Exercises_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercício`);
	return /** @type {LocalizedString} */ (`${i?.count} exercícios`)
	
};

const es_419_draft_exercises_count = /** @type {(inputs: Draft_Exercises_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 ejercicio`);
	return /** @type {LocalizedString} */ (`${i?.count} ejercicios`)
	
};

const pt_pt2_draft_exercises_count = /** @type {(inputs: Draft_Exercises_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercício`);
	return /** @type {LocalizedString} */ (`${i?.count} exercícios`)
	
};

const fr_fr2_draft_exercises_count = /** @type {(inputs: Draft_Exercises_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercice`);
	return /** @type {LocalizedString} */ (`${i?.count} exercices`)
	
};

const de_de2_draft_exercises_count = /** @type {(inputs: Draft_Exercises_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Übung`);
	return /** @type {LocalizedString} */ (`${i?.count} Übungen`)
	
};

const it_it2_draft_exercises_count = /** @type {(inputs: Draft_Exercises_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 esercizio`);
	return /** @type {LocalizedString} */ (`${i?.count} esercizi`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 exercise" |
* | * | "{count} exercises" |
*
* @param {Draft_Exercises_CountInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_exercises_count = /** @type {((inputs: Draft_Exercises_CountInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Exercises_CountInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_exercises_count(inputs)
	if (locale === "es-419") return es_419_draft_exercises_count(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_exercises_count(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_exercises_count(inputs)
	if (locale === "de-DE") return de_de2_draft_exercises_count(inputs)
	if (locale === "it-IT") return it_it2_draft_exercises_count(inputs)
	return en_us2_draft_exercises_count(inputs)
});
export { draft_exercises_count as "draft.exercises_count" }